import { RefObject, useEffect, useState } from 'react';

/**
 * Largura do elemento, acompanhando redimensionamentos (sidebar recolhida, janela). Devolve 0
 * enquanto não mediu — quem usa trata 0 como "desconhecido" e escolhe o layout mais largo.
 */
export default function useElementWidth(ref: RefObject<HTMLElement | null>): number {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver((entries) => {
      setWidth(Math.round(entries[0]?.contentRect.width ?? 0));
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);

  return width;
}
